import { render, staticRenderFns } from "./ModalDocumentosAnalise.vue?vue&type=template&id=54868d76&lang=pug"
import script from "./ModalDocumentosAnalise.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAnalise.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentosAnalise.vue?vue&type=style&index=0&id=54868d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports